import React, { useEffect, useState } from "react"
import DayJsUtils from "@date-io/dayjs"
import Dayjs from "dayjs"
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers"
import { useTranslation } from "react-i18next"
import siteLanguages from "../../config/sitelanguages.json"
import { contrastCalendar, convertUTCDateToLocalDate } from "../../utils"
import { ThemeProvider, useTheme } from "@material-ui/styles"
import { createTheme } from "@material-ui/core"
import { useSelector } from "react-redux"
import config from "../../config"

function DatePicker({ formik, name, label, ...rest }) {
  const { theme: { bgColors, colors } } = useTheme()  
  const { i18n: { language: i18nLanguage } } = useTranslation()
  const [localeLoaded, setLocaleLoaded] = useState(false)
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)

  const isContrast = themeState !== config.THEMES_MODES.LIGHT
  const date = formik.values[name] ? formik.values[name] : ""
  const dateWithoutUTC = convertUTCDateToLocalDate(date)
  const validDate = Dayjs(dateWithoutUTC).isValid() ? Dayjs(dateWithoutUTC) : null
  const contrastTheme = contrastCalendar(bgColors, colors, createTheme)
  const defaultTheme = createTheme()

  useEffect(() => {
    const loadLocale = async () => {
      try {
        const localeName = siteLanguages[i18nLanguage]?.extName || "en-gb"
        await import(`dayjs/locale/${localeName}`)
        Dayjs.locale(localeName)
        setLocaleLoaded(true)
      } catch (error) {
        console.error("Error loading locale:", error)
      }
    }

    loadLocale()
  }, [i18nLanguage])

  const handleDateChange = (date) => {
    if (date && !isNaN(date.get('year'))) {
      const newDate = new Date(date)
      const dateToUTCString = Dayjs(newDate).format("YYYY-MM-DD HH:mm:ss")
      formik.setFieldValue(name, dateToUTCString)
    }
  }

  if (!localeLoaded) {
    return <div>Loading...</div>
  }

  return (
    <ThemeProvider theme={isContrast ? contrastTheme : defaultTheme}>
    <MuiPickersUtilsProvider utils={DayJsUtils}>
      <KeyboardDatePicker
        id="date-picker-dialog"
        label={label}
        InputLabelProps={{ style: { color: colors.colorText } }}
        format="YYYY-MM-DD"
        inputVariant="outlined"
        fullWidth
        {...rest}
        value={validDate}
        InputProps={{ style: {  color: colors.colorText, height: '58px', backgroundColor: bgColors.bgPrimary200, } }}
        onChange={handleDateChange}
        KeyboardButtonProps={{
          'aria-label': 'change date',
          style: { color: colors.colorText }
        }}
      />
    </MuiPickersUtilsProvider>
    </ThemeProvider>
  )
}

export default DatePicker